import comp from "./Checkbox";
export default comp;
